import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 48px auto 0;
  padding: 30px 20px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const ImageCard = styled.div`
  flex: 1.5;
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 20px;
  overflow: visible;
  backdrop-filter: blur(10px);
  min-width: 600px;

  @media (max-width: 1024px) {
    min-width: 100%;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 2px;
    background: linear-gradient(135deg, #335da9, #8bc34a);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -40px;
    left: 0;
    right: 0;
    height: 40px;
    z-index: -1;
  }
`;

const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  min-width: 400px;

  @media (max-width: 1024px) {
    min-width: 100%;
  }
`;

const MainTitle = styled.h2`
  font-size: 4rem;
  color: #4b9bff;
  margin-bottom: 20px;
  font-weight: 600;
`;

const SubTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SourceText = styled.h3`
  font-size: 3.5rem;
  color: #000;
  font-weight: 500;
  line-height: 1.2;
`;

const ShipText = styled.h3`
  font-size: 3.5rem;
  color: #000;
  font-weight: 600;
  font-style: italic;
  line-height: 1.2;
`;

const Description = styled.p`
  font-size: 2rem;
  line-height: 1.4;
  color: #333;
  margin-top: 20px;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 15px;
  max-height: 600px;
  object-fit: contain;
`;

const FeaturedCard = () => {
  return (
    <CardContainer>
      <ContentWrapper>
        <TextContent>
          <MainTitle>Dropship India:</MainTitle>
          <SubTitle>
            <SourceText>Source Anything,</SourceText>
            <ShipText>Ship Everything</ShipText>
          </SubTitle>
          <Description>
            Become a part of India's fastest growing dropshipping platform!
          </Description>
        </TextContent>
        <ImageCard>
          <ImageWrapper>
            <Image
              src="/images/dsi-home-page.png"
              alt="Dropship India Products"
            />
          </ImageWrapper>
        </ImageCard>
      </ContentWrapper>
    </CardContainer>
  );
};

export default FeaturedCard;
